import { useEffect, useMemo, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { API_BASE_URL } from "../utils/constants";
import { motion } from "framer-motion";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import Confetti from "react-confetti";
import axios from "axios";

const PaginaSucessoExclusao = () => {
  const { hash } = useParams();
  const navigate = useNavigate();
  const location = useLocation();

  const [exclusao, setExclusao] = useState(null);
  const [loading, setLoading] = useState(true);

  const acaoState = location.state?.acao;

  useEffect(() => {
    const carregarPagina = async () => {
      try {
        const response = await axios.get(
          `${API_BASE_URL}/api/v1/exclusao/${hash}`
        );
        setExclusao(response.data);
      } catch (error) {
        console.error(
          "Acesso negado ou exclusão não encontrada:",
          error.response?.data?.message
        );
        navigate("/acesso-invalido");
      } finally {
        setLoading(false);
      }
    };

    if (hash) carregarPagina();
  }, [hash, navigate]);

  const statusFinal = useMemo(() => {
    if (acaoState === "confirmado" || acaoState === "rejeitado") return acaoState;
    const status = exclusao?.status;
    if (status === "confirmado") return "confirmado";
    if (status === "rejeitado") return "rejeitado";
    return null;
  }, [acaoState, exclusao?.status]);

  if (loading) {
    return (
      <div className="flex items-center justify-center h-full">
        <p className="text-xl">Carregando informações...</p>
      </div>
    );
  }

  const whatsappLink = exclusao?.loc?.whatsapp
    ? `https://wa.me/${exclusao.loc.whatsapp}`
    : "#";

  const titulo =
    statusFinal === "confirmado"
      ? "Exclusão confirmada!"
      : statusFinal === "rejeitado"
      ? "Exclusão rejeitada!"
      : "Resposta registrada!";

  const subtitulo =
    statusFinal === "confirmado"
      ? "A solicitação de exclusão foi confirmada com sucesso."
      : statusFinal === "rejeitado"
      ? "A solicitação de exclusão foi rejeitada com sucesso."
      : "Sua resposta foi registrada com sucesso.";

  return (
    <>
      <div className="fixed inset-0 -z-10 animated-bg pointer-events-none" />
      <div className="relative z-10 flex flex-col min-h-screen overflow-x-hidden">
        <div className="flex flex-1 flex-col items-center justify-center text-center text-white overflow-hidden p-4">
          <Confetti recycle={false} numberOfPieces={400} />

          <motion.div
            initial={{ scale: 0 }}
            animate={{ scale: 1 }}
            transition={{
              type: "spring",
              stiffness: 200,
              damping: 15,
              delay: 0.2,
            }}
            className="bg-white rounded-full p-6 shadow-xl mb-6"
          >
            <motion.svg
              xmlns="http://www.w3.org/2000/svg"
              className="w-24 h-24 text-green-500"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              initial={{ pathLength: 0 }}
              animate={{ pathLength: 1 }}
              transition={{ duration: 1.2, ease: "easeInOut", delay: 0.2 }}
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
              />
            </motion.svg>
          </motion.div>

          <motion.h1
            className="text-5xl font-extrabold mb-3 drop-shadow-lg"
            initial={{ scale: 0.8, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{
              type: "spring",
              stiffness: 200,
              damping: 10,
              delay: 0.5,
            }}
          >
            {titulo}
          </motion.h1>

          <motion.p
            className="text-xl mb-6"
            initial={{ y: -30, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.8, delay: 1.0 }}
          >
            {subtitulo}
          </motion.p>

          {exclusao && exclusao.loc ? (
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 0.8, delay: 1.2 }}
            >
              <p className="text-lg mb-4">
                Se necessário, você pode entrar em contato com o loc{" "}
                <strong className="text-green-400 text-2xl">
                  {exclusao.loc.nome}
                </strong>
                .
              </p>
              <a
                href={whatsappLink}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-block px-8 py-3 bg-green-500 text-white font-bold rounded-lg shadow-lg
                hover:bg-green-600 transition-transform transform hover:scale-105"
              >
                <FontAwesomeIcon icon={faWhatsapp} className="mr-2 h-5 w-5" />
                WhatsApp
              </a>
            </motion.div>
          ) : (
            <motion.p className="text-md opacity-80">
              Não foi possível carregar os detalhes do localizador.
              <br />
              Você já pode fechar esta aba.
            </motion.p>
          )}
        </div>
      </div>
    </>
  );
};

export default PaginaSucessoExclusao;

